<div nz-row [nzGutter]="12" [formGroup]="controlGroup">
  <div nz-col [nzSpan]="zipSpan">
    <nz-form-item>
      <nz-form-label *ngIf="showLabels">{{'reg.talent.zip.label' | translate}}</nz-form-label>
      <nz-form-control [nzErrorTip]="zipErrorTpl">
        <ng-container *ngIf="zipOnly; else zipDropdown">
          <nz-input-group [nzSuffix]="suffixTemplateInfo" [nzSize]="nzSize" [nzStatus]="groupError ? 'error' : ''">
            <input
              nz-input
              [placeholder]="'reg.talent.zip.label' | translate"
              formControlName="postalCode"
              (focus)="handleZipFocus()"
              (blur)="handleZipBlur()"/>
          </nz-input-group>
        </ng-container>
        <ng-template #zipDropdown>
          <nz-select
            formControlName="postalCode"
            nzShowSearch
            nzServerSearch
            nzAllowClear
            [nzFilterOption]="nzFilterOption"
            [nzLoading]="zipLoading"
            [nzPlaceHolder]="'reg.talent.zip.label' | translate"
            (nzOnSearch)="searchZip($event)"
          >
            <nz-option
              *ngFor="let option of zipOptions"
              [nzValue]="option.postalCode"
              [nzLabel]="option.postalCode + (option.city || option.country ? ' — ' + (option.city || '') + (option.country ? ', ' + option.country : '') : '')"
            ></nz-option>
          </nz-select>
        </ng-template>
        <ng-template #suffixTemplateInfo>
          <span *ngIf="loading" nz-icon nzType="loading" nzTheme="outline"></span>
        </ng-template>
      </nz-form-control>
      <ng-template #zipErrorTpl let-control>
        <ng-container *ngIf="control.hasError('minlength')">Invalid code</ng-container>
      </ng-template>
    </nz-form-item>
  </div>
  <div *ngIf="!zipOnly" nz-col [nzSpan]="distanceInput ? 7 : 9">
    <nz-form-item>
      <nz-form-label *ngIf="showLabels" [nzRequired]="required">{{'reg.talent.city.label' | translate}}</nz-form-label>
      <nz-form-control>
        <nz-select
          [nzSize]="nzSize"
          formControlName="city"
          nzShowSearch
          nzServerSearch
          nzAllowClear
          [nzFilterOption]="nzFilterOption"
          [nzLoading]="cityLoading"
          [nzPlaceHolder]="'reg.talent.city.label' | translate"
          (nzOnSearch)="searchCity($event)"
        >
          <nz-option
            *ngFor="let option of cityOptions"
            [nzValue]="option.city"
            [nzLabel]="option.label"
          ></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>
  <div *ngIf="!zipOnly" nz-col [nzSpan]="distanceInput ? 7 : 9">
    <nz-form-item>
      <nz-form-label *ngIf="showLabels" [nzRequired]="required">{{'reg.talent.country.label' | translate}}</nz-form-label>
      <nz-form-control>
        <mh-country-input
          formControlName="country"
          [returnCountryName]="true"
          (countryCodeChange)="onCountryCodeSelected($event)"
        ></mh-country-input>
      </nz-form-control>
    </nz-form-item>
  </div>
  <div nz-col [nzSpan]="zipOnly ? 12 : 6" *ngIf="distanceInput">
    <nz-form-item>
      <nz-form-label *ngIf="showLabels">
        <mh-explanation-label [labelKey]="'admin.jo.radius-km.label'"></mh-explanation-label>
      </nz-form-label>
      <nz-form-control>
        <nz-select nzSize="default" formControlName="radius"
                   [nzPlaceHolder]="'admin.jo.radius-km.label' | translate"
                   [compareWith]="compareCmsNameValue"
                   nzAllowClear
        >
          <nz-option
            *ngFor="let option of (radiusOptions$ | async)"
            [nzLabel]="option.name | translate" [nzValue]="option"
          ></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>
</div>
